import React from 'react';
import { Image } from 'semantic-ui-react';

const InfluencerIcon = props => (
  <Image {...props} src="/icons/my-influencers.svg" />
);

export default InfluencerIcon;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-icon/index.js
 **/